<template>
    <div class="guide-box">
        <img class="guide-img" :src="`http://www.artgogo.com/online-exhibition/amicitia/img/${src}`">
        <ChangeButton @change="changeLanguage"></ChangeButton>
    </div>
</template>
<style>
    .guide-box{
        position: absolute;
        left:0;
        top: 0;
        height:100%;
        width:100%;

    }
    .guide-box .guide-img{
        height:100%;
        width:100%;
    }
</style>
<script>
import ChangeButton from './ChangeButton.vue'

export default{
    data(){
        return{
            src:'1.png'
        }
    },
    components:{
        ChangeButton 
    },
    methods:{
        changeLanguage(para){
            if(para == 'english'){
                this.src= '2.png'
            }else{
                this.src= '1.png'
            }
        }
    }
}
</script>
